import PosthogService from '~/services/posthog/PosthogService';

export interface IShiftRequestEnhancedRateExperimentExposedPayload {
  flagKey: string;
  variant: string;
}

/**
 * Fires once per shift request, only for offices that actually qualify for the enhanced-rate
 * treatment (a single shift within 48h of start, with a backend-provided enhanced rate). Used
 * as the experiment's custom exposure event so the control group is not diluted by offices that
 * would never have seen the enhanced rate (multi-shift or >48h requests). Carries the PostHog
 * experiment attribution properties so the variant can be resolved downstream.
 * Event: dental_portal:shift_request:enhanced_rate_experiment_exposed
 */
export function fireShiftRequestEnhancedRateExperimentExposed(
  payload: IShiftRequestEnhancedRateExperimentExposedPayload,
): void {
  PosthogService.getInstance().track(
    'dental_portal:shift_request:enhanced_rate_experiment_exposed',
    {
      $feature_flag: payload.flagKey,
      $feature_flag_response: payload.variant,
    },
  );
}
